/* src/app/modules/invoice/tickets/ticket-dialog-rectification.component.css */
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dlg-hdr__icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, .12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dlg-hdr__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #e3fd64;
}
.dlg-hdr__title > div > span {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
}
.dlg-hdr__sub {
  display: block;
  font-size: 12px;
  color: #6b7280;
}
.dlg-hdr__close {
  color: #6b7280;
}
.dlg-body {
  padding: 24px 24px 8px !important;
}
.dlg-actions {
  padding: 12px 20px !important;
  border-top: 1px solid #e5e7eb;
  gap: 8px;
}
.dlg-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
.rectify-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fff8e6;
  border: 1px solid #f4fec1;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 4px;
}
.rectify-info mat-icon {
  color: #e3fd64;
  font-size: 20px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 1px;
}
.rectify-info__text {
  font-size: 13.5px;
  color: #374151;
  line-height: 1.5;
}
.rectify-info__text strong {
  color: #1a1d23;
}
/*# sourceMappingURL=ticket-dialog-rectification.component.css.map */
